"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const __1 = require("../../");
const buff_skill_1 = tslib_1.__importDefault(require("../common/buff-skill"));
const single_attack_1 = tslib_1.__importDefault(require("../common/single-attack"));
exports.amonojakuao_skill1 = new single_attack_1.default(1, '乱打', 0.33, 0, 3, true);
exports.amonojakuao_skill2 = new buff_skill_1.default(2, '低吟', 2, (_, sourceId, targetId) => __1.Buff.build(sourceId, targetId)
    .name('低吟', 1)
    .countDown(1)
    .buffAP(__1.BattleProperties.SPD, __1.EffectTypes.FIXED, 40)
    .end());
